'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useReturns = require('../../hooks/useReturns.js');
var pudoMethod = require('../../transformers/pudoMethod.js');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');
var reactQuery = require('react-query');
var reactRouterDom = require('react-router-dom');
var generated = require('../../graphql/generated.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ConfirmationPage = () => {
  var _submittedReturn$pudo2;
  const [shipment, setShipment] = React.useState();
  const [type, setType] = React.useState();
  const [email, setEmail] = React.useState();
  const [providerMoniker, setProviderMoniker] = React.useState();
  const [newEmailStatus, setNewEmailStatus] = React.useState({
    status: 'idle'
  });
  const {
    submittedReturn,
    client
  } = useReturns["default"]();
  const navigate = reactRouterDom.useNavigate();
  const {
    mutate: emailSubmittedReturnDetails
  } = reactQuery.useMutation({
    onError: () => setNewEmailStatus({
      status: 'error'
    }),
    mutationFn: async _ref => {
      let {
        orderId,
        emailAddress
      } = _ref;
      if (!client) throw new Error('Client not initialized');
      if (!orderId) throw new Error('Missing order info');
      setNewEmailStatus({
        status: 'loading'
      });
      const {
        data: emailData
      } = await client.mutate({
        mutation: generated.EmailSubmittedReturnDetailsDocument,
        variables: {
          returnId: orderId,
          emailAddress
        }
      });
      if (!emailData) {
        setNewEmailStatus({
          status: 'error'
        });
        throw new Error('Cancel unsuccessful');
      }
      setNewEmailStatus({
        status: 'success'
      });
    }
  });
  React.useEffect(() => {
    var _submittedReturn$retu, _submittedReturn$cust, _submittedReturn$pudo;
    setShipment(submittedReturn === null || submittedReturn === void 0 ? void 0 : (_submittedReturn$retu = submittedReturn.returnShipments) === null || _submittedReturn$retu === void 0 ? void 0 : _submittedReturn$retu[0]);
    setType(pudoMethod.getPudoMethodName(submittedReturn === null || submittedReturn === void 0 ? void 0 : submittedReturn.pudoOption));
    setEmail((submittedReturn === null || submittedReturn === void 0 ? void 0 : (_submittedReturn$cust = submittedReturn.customer) === null || _submittedReturn$cust === void 0 ? void 0 : _submittedReturn$cust.email) || '');
    setProviderMoniker((submittedReturn === null || submittedReturn === void 0 ? void 0 : (_submittedReturn$pudo = submittedReturn.pudoOption.pudoProvider) === null || _submittedReturn$pudo === void 0 ? void 0 : _submittedReturn$pudo.moniker) || '');
  }, [submittedReturn]);
  const handleSubmit = _ref2 => {
    let {
      subComponent,
      value
    } = _ref2;
    if (subComponent === 'emailSubmittedReturnDetails') {
      if (!(value !== null && value !== void 0 && value.emailAddress) || (value === null || value === void 0 ? void 0 : value.emailAddress) === '') return;
      if (!(submittedReturn !== null && submittedReturn !== void 0 && submittedReturn.id)) return;
      emailSubmittedReturnDetails({
        emailAddress: value.emailAddress,
        orderId: submittedReturn.id
      });
      setEmail(value === null || value === void 0 ? void 0 : value.emailAddress);
    }
  };
  if (!submittedReturn) {
    navigate('/');
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: '0.5rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    confirmation: {
      shipment,
      type,
      providerMoniker,
      email,
      location: submittedReturn === null || submittedReturn === void 0 ? void 0 : (_submittedReturn$pudo2 = submittedReturn.pudoOption.selectedDropOff) === null || _submittedReturn$pudo2 === void 0 ? void 0 : _submittedReturn$pudo2.dropOffLocation,
      onSubmit: handleSubmit,
      alternateEmailToggle: true,
      newEmailStatus
    }
  }));
};

exports["default"] = ConfirmationPage;
